/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import React from 'react';
import { Title } from '@exo/frontend-components-insurance';
import * as S from './ForgotPasswordResponse.styles';
import { Button } from '@exo/frontend-components-base';
import { ArrowLeft16, ArrowRight16 } from '@carbon/icons-react';

export const ResetPasswordResponse = ({
  children,
  title,
  subtitle,
  text,
  leftButtonLabel,
  rightButtonLabel,
  leftButtonFn,
  rightButtonFn
}: Props) => {
  return (
    <S.ResetPasswordResponse>
      <Title title={title} />

      <S.Container>
        {subtitle && <S.Subtitle>{subtitle}</S.Subtitle>}
        <S.TextContent>{children ?? text}</S.TextContent>

        <S.Buttons>
          <div>
            {leftButtonLabel && (
              <Button
                variant="light"
                label={leftButtonLabel}
                iconPosition="left"
                icon={<ArrowLeft16 />}
                onClick={leftButtonFn}
              />
            )}
          </div>
          <div>
            {rightButtonLabel && (
              <Button
                variant="light"
                label={rightButtonLabel}
                iconPosition="right"
                icon={<ArrowRight16 />}
                onClick={rightButtonFn}
              />
            )}
          </div>
        </S.Buttons>
      </S.Container>
    </S.ResetPasswordResponse>
  );
};

type Props = {
  children?: any;
  title: string;
  subtitle?: string;
  text?: string;
  leftButtonLabel?: string;
  rightButtonLabel?: string;
  rightButtonFn?: (e?: any) => void;
  leftButtonFn?: (e?: any) => void;
};
